<template>
  <div>
    <v-form ref="form">
      <v-dialog
        v-model="isShowRolesModal"
        :overlay="false"
        fullscreen
        transition="dialog-bottom-transition"
      >
        <template v-slot:activator="{ on }">
          <v-btn
            color="primary"
            dark
            class="mb-2"
            v-on="on"
          >
            Create Role
          </v-btn>
        </template>
        <v-card>
          <v-app-bar flat class="card-toolbar-title">
            <v-toolbar-title>{{ formTitle }}</v-toolbar-title>
            <v-spacer />
            <v-btn icon @click.native="closeModal">
              <v-icon>close</v-icon>
            </v-btn>
          </v-app-bar>
          <v-container fluid grid-list-md>
            <v-layout row wrap>
              <v-flex xs12 md6>
                <v-text-field
                  v-if="editedItemIndex !== -1"
                  id="roleName"
                  v-model="roleName"
                  :disabled="true"
                  class="required"
                  name="roleName"
                  label="Role Name"
                />
                <v-autocomplete
                  v-if="editedItemIndex === -1"
                  id="roleName"
                  v-model="roleName"
                  :items="getGroupListNoAdmin"
                  :rules="required"
                  name="roleName"
                  label="Role Name"
                  class="required"
                  item-value="value"
                  item-text="value"
                />
                <v-select
                  id="client"
                  v-model="client"
                  :items="clientDetails"
                  :disabled="editedItemIndex !== -1"
                  :rules="requiredId"
                  class="required"
                  item-value="id"
                  item-text="clientNameDesc"
                  name="client"
                  label="Client"
                />
              </v-flex>
              <v-flex xs12 md6>
                <v-textarea
                  id="roleDescription"
                  v-model="roleDescription"
                  name="roleDescription"
                  label="Role Description"
                  textarea
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md3>
                <h3>Total Features Selected: {{ roleFeatures.length }}</h3>
                <v-switch
                  v-model="isIsSelectAllFeatures"
                  label="Select All Features"
                />
              </v-flex>
            </v-layout>
            <v-layout row wrap>
              <v-flex xs12 md3 class="large-spaced">
                <v-card>
                  <v-card-title class="card-title large-spaced"><h3>Features</h3></v-card-title>
                  <v-divider />
                  <v-list dense class="large-spaced">
                    <v-list-item v-for="item in features.landing" :key="item.featureId">
                      <v-list-item-action>
                        <v-checkbox
                          :id="item.featureId.toString()"
                          v-model="roleFeatures"
                          :value="item.featureId"
                          :name="item.featureId"
                          color="primary"
                        />
                      </v-list-item-action>
                      <v-list-item-content class="medium-spaced">
                        <v-list-item-title>
                          <label :for="item.featureId"><strong>{{ item.featureName }}</strong></label>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-checkbox
                          :id="item.viewFeatureId?item.viewFeatureId.toString():'-1'"
                          v-model="roleFeatures"
                          :value="item.viewFeatureId"
                          :name="item.viewFeatureId"
                          :disabled="!item.viewFeatureId"
                          :indeterminate="!item.viewFeatureId"
                          color="primary"
                        />
                      </v-list-item-action>
                      <v-list-item-content class="small-spaced">
                        <v-list-item-title>
                          <label :for="item.viewFeatureId">View</label>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-checkbox
                          :id="item.updateFeatureId?item.updateFeatureId.toString():'-1'"
                          v-model="roleFeatures"
                          :value="item.updateFeatureId"
                          :name="item.updateFeatureId"
                          :disabled="!item.updateFeatureId"
                          :indeterminate="!item.updateFeatureId"
                          color="primary"
                        />
                      </v-list-item-action>
                      <v-list-item-content class="small-spaced">
                        <v-list-item-title>
                          <label :for="item.updateFeatureId">Update</label>
                        </v-list-item-title>
                      </v-list-item-content>
                      <v-list-item-action>
                        <v-checkbox
                          :id="item.addFeatureId?item.addFeatureId.toString():'-1'"
                          v-model="roleFeatures"
                          :value="item.addFeatureId"
                          :name="item.addFeatureId"
                          :disabled="!item.addFeatureId"
                          :indeterminate="!item.addFeatureId"
                          color="primary"
                        />
                      </v-list-item-action>
                      <v-list-item-content class="small-spaced">
                        <v-list-item-title>
                          <label :for="item.addFeatureId">Add</label>
                        </v-list-item-title>
                      </v-list-item-content>
                    </v-list-item>
                  </v-list>
                </v-card>
              </v-flex>
              <v-flex large-spaced xs12 md3>
                <v-card>
                  <v-card-title class="card-title"><h3>View/Update Member Tabs</h3></v-card-title>
                  <v-divider />
                  <v-list dense class="view-member-card">
                    <template v-for="item in features.view">
                      <v-list-item :key="item.featureId">
                        <v-list-item-content class="small-title">
                          <v-list-item-title>
                            <strong>{{ item.featureName }}</strong>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action class="view-checkbox">
                          <v-checkbox
                            :id="item.viewFeatureId?item.viewFeatureId.toString():'-1'"
                            v-model="roleFeatures"
                            :value="item.viewFeatureId"
                            :name="item.viewFeatureId"
                            color="primary"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            <label :for="item.viewFeatureId">View</label>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox
                            :id="item.updateFeatureId.toString()"
                            v-model="roleFeatures"
                            :value="item.updateFeatureId"
                            :name="item.updateFeatureId"
                            :disabled="item.updateFeatureId == ''"
                            :indeterminate="item.updateFeatureId == ''"
                            color="primary"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            <label :for="item.updateFeatureId">Update</label>
                          </v-list-item-title>
                        </v-list-item-content>
                        <v-list-item-action>
                          <v-checkbox
                            :id="item.addFeatureId.toString()"
                            v-model="roleFeatures"
                            :value="item.addFeatureId"
                            :name="item.addFeatureId"
                            :disabled="item.addFeatureId == ''"
                            :indeterminate="item.addFeatureId == ''"
                            color="primary"
                          />
                        </v-list-item-action>
                        <v-list-item-content>
                          <v-list-item-title>
                            <label :for="item.addFeatureId">Add</label>
                          </v-list-item-title>
                        </v-list-item-content>
                      </v-list-item>
                    </template>
                  </v-list>
                </v-card>
              </v-flex>
              <v-flex xs12 md3>
                <v-btn id="submitRole" name="submitRole" color="primary" @click.native="save">Submit</v-btn>
              </v-flex>
            </v-layout>
          </v-container>
        </v-card>
      </v-dialog>
    </v-form>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex'
export default {
  name: 'manage-roles-modal',
  data() {
    return {
      required: [
        v => !!v || 'Required'
      ],
      requiredId: [
        v => !!v.id || 'Required'
      ]
    }
  },
  computed: {
    ...mapState('manageClient', ['clientDetails']),
    ...mapState('manageRoles', ['editedItemIndex', 'editedItem', 'features', 'selectedFeatures', 'showRolesModal', 'roleDetails', 'isSelectAllFeatures']),
    ...mapGetters('oktaGroups', ['getGroupListNoAdmin']),
    isIsSelectAllFeatures: {
      get() {
        return this.isSelectAllFeatures
      },
      set(value) {
        this.selectAllFeatures(value)
      }
    },
    isShowRolesModal: {
      get() {
        return this.showRolesModal
      },
      set(value) {
        this.setShowRolesModal(value)
      }
    },
    roleName: {
      get() {
        return this.roleDetails.roleName
      },
      set(value) {
        this.updateRoleDetails({
          key: 'roleName',
          value
        })
      }
    },
    client: {
      get() {
        return {
          id: this.roleDetails.clientId,
          clientNameDesc: this.roleDetails.clientNameDesc
        }
      },
      set(value) {
        this.updateRoleDetails({
          key: 'clientId',
          value
        })
      }
    },
    roleDescription: {
      get() {
        return this.roleDetails.roleDescription
      },
      set(value) {
        this.updateRoleDetails({
          key: 'roleDescription',
          value
        })
      }
    },
    roleFeatures: {
      get() {
        return this.selectedFeatures
      },
      set(value) {
        this.setSelectedFeatures(value)
      }
    },
    formTitle() {
      return this.editedItemIndex === -1 ? 'Create Role' : 'Edit Role'
    }
  },
  methods: {
    ...mapActions('manageRoles', ['saveRole']),
    ...mapMutations('manageRoles',
      ['setSelectedFeatures',
        'updateRoleDetails',
        'setShowRolesModal',
        'resetRoleDetails',
        'selectAllFeatures']),
    save() {
      // Save/close here when all validates or it's an edited item as you know it has required fields
      if (this.$refs.form.validate() || this.editedItemIndex !== -1) {
        this.saveRole()
        this.closeModal()
      }
    },
    closeModal() {
      this.isShowRolesModal = false
      setTimeout(() => {
        this.resetRoleDetails()
      }, 300)
    }
  }
}
</script>

<style lang="scss" scoped>
  .card-title {
    background-color: $black-3;
    color: $color-primary;
  }

  .card-toolbar-title {
    background-color: $color-secondary;
  }

  .view-checkbox {
    min-width: 0px;
  }

  .small-spaced {
    min-width: 45px;
  }

  .small-title {
    min-width: 125px;
  }

  .medium-spaced {
    min-width: 165px;
  }

  .large-spaced {
    min-width: 550px;
  }

  .view-member-card {
  }
</style>
